<template>
    <div>
        <el-tag v-if="isTag" :type="tagType" size="mini" v-text="text"></el-tag>
        <div class="state-wrapper" v-else>
            <span v-text="text" :style="[styleObj]"> </span>
            <div v-if="data === 'locking'">
                <el-tooltip class="item" effect="dark" :content="content" placement="bottom-start">
                    <span @click="specificReason" class="state-locking-txt"> - {{ row.addData.lockReason }}</span>
                </el-tooltip>
            </div>
        </div>
    </div>
</template>

<script>
import LockingQuestionModal from './LockingQuestionModal.vue';

export default {
    name: "StateColumn",
    components: {
        LockingQuestionModal,
    },
    props: ['data', 'row'],
    data() {
        return {
            isTag: false,
            tagType: '',
        };
    },
    computed: {
        label() {
            return {
                first: {
                    text: this.$t("zhiji.knowlege.firstQuestion"),
                    type: 'success'
                },
                reveal: {
                    text: this.$t("zhiji.knowlege.reveal"),
                    type: ''
                }
            };
        },
        text() {
            if (this.data && this.label[this.data]) {
                this.isTag = true;
                this.tagType = this.label[this.data].type;
                return this.label[this.data].text;
            } else {
                this.isTag = false;
                this.tagType = '';
                if (this.data === 'locking') {
                    return ` ● ${this.$t("zhiji.knowlege.locked")}`;
                }
                return this.data == 1 ? ` ● ${this.$t("zhiji.knowlege.alreadyOn")}` : this.$t("zhiji.knowlege.alreadyOff");
            }
        },
        styleObj() {
            if (this.data == 1) {
                return { color: '#67c23a' };
            } else if (this.data === 'locking') {
                return { color: '#ff8c14' };
            }
        },
        content() {
            return this.$t("zhiji.knowlege.LockReasonTip");
        }
    },
    methods: {
        specificReason() {
            this.$store.dispatch("zhiji/showModal", {
                type: LockingQuestionModal,
                data: {
                    inputMsg: this.row.addData.lockReason,
                    confirm: (val) => {
                        this.$store.dispatch('zhiji/quesLockingStatusChange', {
                            question: this.row.columns.find(e => e.colId === "standQuestion").data.value,
                            questionId: this.row.rowId,
                            reason: val,
                            status: 1,
                        });
                    }
                }
            });
        }
    }
};
</script>

<style lang="less" scoped>
.state-wrapper {
    display: flex;
    .state-locking-txt {
        display: inline-block;
        max-width: 108px;
        color: #888;
        cursor: pointer;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
}
</style>